import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { User } from '../interfaces/general';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private url = `${environment.api_url}/preoperational`;
  private current_user: User | null = null;
  private userSubject = new BehaviorSubject<User | null>(null);

  constructor(
    private http: HttpClient,
    private router: Router,
  ) {
    this.checkSession();
  }

  login(data: any): Observable<boolean | undefined> {
    return this.http.post<User>(`${this.url}/account/login/`, data).pipe(
      map((user: User) => {
        this.saveLocalStorage(user);
        return true;
      }),
    );
  }

  get user$(): Observable<User | null> {
    return this.userSubject.asObservable();
  }

  get userValue(): User | null {
    return this.userSubject.getValue();
  }

  get headers(): HttpHeaders {
    let user = this.userValue as User;

    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    if ('username' in user) {
      headers = headers.set('EGC-USER', user.id!.toString());
    } else {
      headers = headers.set('EGC-OPERARIO', user.id!.toString());
    }
    user.company &&
      (headers = headers.set(
        'EGC-EMPRESA-IDENTIFIER',
        user.company.toString(),
      ));
    user.region &&
      (headers = headers.set('EGC-REGION-IDENTIFIER', user.region.toString()));
    return headers;
  }

  logout(): void {
    localStorage.clear();
    this.userSubject.next(null);
    this.router.navigate(['/login']);
  }

  private checkSession(): void {
    const user = JSON.parse(localStorage.getItem('user')!) || null;

    if (user) {
      this.userSubject.next(user);
    }
  }

  private saveLocalStorage(user: User): void {
    localStorage.setItem('user', JSON.stringify(user));
    this.userSubject.next(user);
  }
}
